import type { FaireProductEntity } from "../../entity_types/product";

export const p_hp4fadhsup: FaireProductEntity = {
  token: "p_hp4fadhsup",
  type: "product",
  name: "CZ Pave Evil Eye Ring,Sku#B152",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/88cb4065e78f1aae4038f0c1180fe2e3bf0728db6c7afeb8c7c49496bfaa4f29.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c97d6972e29b0c9116c0141d80f226d8fd8763dcd2b50f24d3dd700109cb4ad3.jpeg",
    "https://cdn.faire.com/fastly/909bbb80e82108a4252d3c3956c05d7a3501e9e27f893007862f4261dde445d2.jpeg",
    "https://cdn.faire.com/fastly/e81ea0026e02bf6443cafe6ee9fad00f0f6f11d352dfc9d97052557f97f205ea.jpeg",
  ],
  priceDollars: 9.73,
  description:
    "BestBeads&Beyond brings you the CZ Pave Evil Eye Ring. This exquisitely designed piece is more than just a ring; it's a statement. The ring showcases intricate craftsmanship, with the cubic zirconia lending a touch of glamour and the gold-filled band providing lasting shine. This band stacked ring is an elegant addition to any jewelry collection. Enjoy the blend of style and quality that BestBeads&Beyond consistently delivers.",
  tags: [],
  msrpDollars: 19.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:23.959Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
